<eretail-modal class="align-items-center position-relative" [isCloseable]="true">
    <!-- <div class="close-button__container">
        <app-button icon="x-lg" buttonClass="bt-danger" mat-dialog-close buttonType="close"/>

    </div> -->
    <eretail-content-wrapper-header [title]="'Gerar Relatório'" subTitle=" " class="w-100">

    </eretail-content-wrapper-header>
    <eretail-dynamic-form
        #dynamicForm
        class="eretail-form-sm" 
        [dynForm]="extractForm"
    >

        <app-button 
            [loading]="isLoading"
            buttonClass="bt-primary w-100 mt-4" 
            formActionSectionItem
            class="w-100"
            (click)="onSubmit()"
            >
            Gerar
        </app-button>

    </eretail-dynamic-form>
</eretail-modal>